import { React, DomeComponent, DomeManipulator } from "@lexriver/dome"
import { GlobalUser } from "../GlobalUser";
import { EnumUserType } from "../enums/EnumUserType";
import css from './BasketExport.m.scss'
import { Settings } from "../../Settings";
import { Checkbox } from "./form/Checkbox";
import { Button } from "./form/Button";
import { Input } from "./form/Input";
import { IBasket } from "../Basket/IBasket";
import { GlobalBasket } from "../GlobalBasket";
import { UrlGenerator } from "../UrlGenerator";
import { RequestMaker } from "../server-queries/RequestMaker";
import { BasketExportAsList } from "./BasketExportAsList";

const filename = 'BasketExport'

interface Attrs {

}

export class BasketExport extends DomeComponent<Attrs> {
    refInputProductListName?: Input
    protected exportToFile = {
        category: true,
        sku: true,
        name: true,
        productUrl: true,
        description: true,
        attributes: true,
        type: true,
        thumb: true,
        thumbUrl: true,
        photo: true,
        photoUrl: true,
        priceRetail: true,
        priceRetailFormat1: false,
        priceSP: false,
        priceWholesale: true,
        quantityAvailable: true,
        quantityToOrder: true,
        sumRetail: true,
        sumSP: false,
        sumWholesale: true,
        properties: true,

    }

    protected requestFile(fileType: 'csv' | 'xlsx' | 'vk-yml', csvSeparator: string) {
        let url = [
            //TODO:
            //Settings.websocketRestServerAddress
            Settings.isProduction ? 'https://uvelina.ru/api/ws' : 'http://uvelina.ru:2020/api/ws',
            'export-basket', GlobalUser.sessionIdO.get(), fileType, csvSeparator || '-',
            this.exportToFile.category ? 1 : 0,
            this.exportToFile.sku ? 1 : 0,
            this.exportToFile.name ? 1 : 0,
            this.exportToFile.productUrl ? 1 : 0,
            this.exportToFile.description ? 1 : 0,
            this.exportToFile.attributes ? 1 : 0,
            this.exportToFile.type ? 1 : 0,
            this.exportToFile.thumb ? 1 : 0,
            this.exportToFile.thumbUrl ? 1 : 0,
            this.exportToFile.photo ? 1 : 0,
            this.exportToFile.photoUrl ? 1 : 0,
            this.exportToFile.priceRetail ? 1 : 0,
            this.exportToFile.priceRetailFormat1 ? 1 : 0,
            this.exportToFile.priceSP ? 1 : 0,
            this.exportToFile.priceWholesale ? 1 : 0,
            this.exportToFile.quantityAvailable ? 1 : 0,
            this.exportToFile.quantityToOrder ? 1 : 0,
            this.exportToFile.sumRetail ? 1 : 0,
            this.exportToFile.sumSP ? 1 : 0,
            this.exportToFile.sumWholesale ? 1 : 0,
            this.exportToFile.properties ? 1 : 0
        ].join('/')
        window.open(url, '_self')
    }

    async assignProductListNameAsync() {
        const userType = await GlobalUser.getUserTypeAsync()
        if ([EnumUserType.Administrator, EnumUserType.SMM].includes(userType) == false) {
            return
        }

        const basket: IBasket = await GlobalBasket.getCurrentBasketAsync()
        if(basket.isEmpty()){
            return
        }
        //await Async.waitMsAsync(100) // sometime setValue on list doesn't affect
        try {
            // await Async.waitForFunctionToReturnTrueAsync(() => {
            //     console.log('00] this.refInputProductListName=', this.refInputProductListName)
            //     return this.refInputProductListName ? true : false
            //     //return DomeManipulator.isInDom(this.refInputProductListName)
            // }, 500, 5000)

            if (!this.refInputProductListName) throw new Error('no refInputProductListName')

            
            const basketStats = await basket.getStatsAsync({ getJsonOrderItems: false })
            //console.log('00] basketStats=', basketStats)
            const listName =
                'Список товаров от ' +
                Settings.formatDateSpecial(new Date()) +
                //Settings.formatDate(new Date().toISOString())+
                //new Date().toISOString() +
                (basketStats.skuQuantity ? (' - ' + Settings.formatCountOfProducts(basketStats.skuQuantity ?? 0)) : '')

            //console.log('00] listName=', listName)
            this.refInputProductListName?.setValue(listName)
            //console.log('00] listName get = ', this.refInputProductListName?.getValue())

        } catch (x) {
            console.error('assignProductListNameAsync failed', x)
        }
    }


    async updateAsync() {
        const isAdmin = await GlobalUser.getUserTypeAsync() === EnumUserType.Administrator
        const isSMM = await GlobalUser.getUserTypeAsync() === EnumUserType.SMM
        if (isAdmin) {
            await DomeManipulator.replaceAllChildrenAsync(this.rootElement,  this.renderForAdmin())
            // await this.assignProductListNameAsync()

        } else if(isSMM){
            await DomeManipulator.replaceAllChildrenAsync(this.rootElement, this.renderForSMM())
            // await this.assignProductListNameAsync()

        } else {
            await DomeManipulator.removeElementAsync(this.rootElement)

        }


    }

    async afterRender() {
        //console.log('$$ unmark all products');
        this.scheduleUpdate() // no need to update here?, because of events. Else is double update.

    }

    render() {
        return <div></div>
    }

    protected renderForAdmin() {
        return (
            <>
                <div class={css.adminExportContainer}>
                    <h3>Экспортировать корзину</h3>
                    <div>
                        Выберите колонки для экспорта
                    </div>
                    <div>
                        <Checkbox isChecked={this.exportToFile.thumb} onChange={x => this.exportToFile.thumb = x}>Фото маленькое</Checkbox>
                        <Checkbox isChecked={this.exportToFile.sku} onChange={(x) => this.exportToFile.sku = x}>Артикул</Checkbox>
                        <Checkbox isChecked={this.exportToFile.name} onChange={x => this.exportToFile.name = x}>Название товара</Checkbox>
                        <Checkbox isChecked={this.exportToFile.description} onChange={x => this.exportToFile.description = x}>Описание товара</Checkbox>
                        <Checkbox isChecked={this.exportToFile.quantityToOrder} onChange={x => this.exportToFile.quantityToOrder = x}>Количество в корзине</Checkbox>
                        <Checkbox isChecked={this.exportToFile.quantityAvailable} onChange={x => this.exportToFile.quantityAvailable = x}>Доступное количество товара</Checkbox>

                        <Checkbox isChecked={this.exportToFile.priceWholesale} onChange={x => this.exportToFile.priceWholesale = x}>Цена оптовая</Checkbox>
                        <Checkbox isChecked={this.exportToFile.priceRetail} onChange={x => this.exportToFile.priceRetail = x}>Цена розничная</Checkbox>
                        <Checkbox isChecked={this.exportToFile.properties} onChange={x => this.exportToFile.properties = x}>Свойства товара (артикул завода, покрытие, ...)</Checkbox>
                        <Checkbox isChecked={this.exportToFile.attributes} onChange={x => this.exportToFile.attributes = x}>Атрибуты товара (размеры, материал)</Checkbox>
                        <Checkbox isChecked={this.exportToFile.type} onChange={x => this.exportToFile.type = x}>Тип товара</Checkbox>
                        <Checkbox isChecked={this.exportToFile.thumbUrl} onChange={x => this.exportToFile.thumbUrl = x}>Фото маленькое ссылка</Checkbox>
                        <Checkbox isChecked={this.exportToFile.photo} onChange={x => this.exportToFile.photo = x}>Фото большое</Checkbox>
                        <Checkbox isChecked={this.exportToFile.photoUrl} onChange={x => this.exportToFile.photoUrl = x}>Фото большое ссылка</Checkbox>
                        <Checkbox isChecked={this.exportToFile.priceRetailFormat1} onChange={x => this.exportToFile.priceRetailFormat1 = x}>Цена розничная в формате "3100 RUB"</Checkbox>
                        <Checkbox isChecked={this.exportToFile.priceSP} onChange={x => this.exportToFile.priceSP = x}>Цена СП</Checkbox>





                        <Checkbox isChecked={this.exportToFile.sumRetail} onChange={x => this.exportToFile.sumRetail = x}>Сумма розничная</Checkbox>
                        <Checkbox isChecked={this.exportToFile.sumSP} onChange={x => this.exportToFile.sumSP = x}>Сумма СП</Checkbox>
                        <Checkbox isChecked={this.exportToFile.sumWholesale} onChange={x => this.exportToFile.sumWholesale = x}>Сумма оптовая</Checkbox>
                        <Checkbox isChecked={this.exportToFile.category} onChange={x => this.exportToFile.category = x}>Название категории</Checkbox>
                        <Checkbox isChecked={this.exportToFile.productUrl} onChange={x => this.exportToFile.productUrl = x}>Ссылка на товар</Checkbox>

                    </div>
                    <div>
                        <div class={css.columns}>
                            <div>
                                <Button text="Экспортировать как Excel файл .xlsx" onClick={() => { this.requestFile('xlsx', ',') }} />
                            </div>
                        </div>

                        <div class={css.columns}>
                            <div>
                                <Button text="Экспортировать как .csv файл разделитель запятая (,)" onClick={() => { this.requestFile('csv', ',') }} />
                            </div>
                            <div>
                                <Button text="Экспортировать как .csv файл разделитель точка с запятой (;)" onClick={() => { this.requestFile('csv', ';') }} />
                            </div>

                        </div>

                        <div class={css.columns}>
                            <Button text="Экспортировать товары для VK (YML формат)" onClick={() => { this.requestFile('vk-yml', '') }} />
                        </div>


                        <BasketExportAsList />


                    </div>
                </div>

            </>


        )
    }

    protected renderForSMM() {
        return (
            <div class={css.adminExportContainer}>
                <h3>Экспортировать корзину</h3>
                <BasketExportAsList />
            </div>
        )
    }

    // renderExportList() {
    //     return (
    //         <div class={css.columns}>
    //             <div style={{ paddingLeft: '10px' }}>
    //                 Название списка товаров
    //             </div>
    //             <div>
    //                 <Input inputType="text" ref={ref => this.refInputProductListName = ref} />
    //             </div>
    //             <div>
    //                 <Button text="Экспортировать как ссылку на список товаров" onClick={async () => { await this.onExportToProductListAsync() }} />
    //             </div>
    //         </div>

    //     )
    // }

    // async onExportToProductListAsync() {
    //     try {
    //         const basket: IBasket = await GlobalBasket.getCurrentBasketAsync()
    //         const list = await basket.getListOfRowsAsync()
    //         const productIds = list.map(x => x.product.id)
    //         const name = this.refInputProductListName?.getValue()
    //         //console.log('productIds=', productIds, 'name=', name)
    //         const listId = await RequestMaker.sendWebsocketJsonRequestAsync({ query: 'admin-productlist-new', params: { name, productIds } }, filename)
    //         if (!listId) {
    //             alert('Ошибка при создании списка!')
    //             return
    //         }
    //         const url = window.location.origin + UrlGenerator.productsByListWithDefaultParameters({ listId: listId as string })
    //         const userType = await GlobalUser.getUserTypeAsync()
    //         const message = 'Список был успешно создан! \n' +
    //             (userType === EnumUserType.Administrator
    //                 ? 'Теперь он доступен в администраторе в разделе `списки товаров` и по ссылке: \n'
    //                 : 'Теперь он доступен по ссылке: \n'
    //             ) +
    //             url +
    //             '\n\n' +
    //             'Желаете скопировать данную ссылку?'

    //         if (confirm(message)) {
    //             await navigator.clipboard.writeText('' + url)
    //         }
    //         return true

    //     } catch (x) {
    //         console.error(filename, x)

    //     }

    // }




}